import validator from 'validator';
import moment from 'moment';
import {momentDatetime, isEditorValueStringEmpty} from '../common';
import {isEmpty, isValidPasswordLength, isValidPasswordPattern} from '../validation';

export const required = value => isEmpty(value) ? 'Required' : undefined;

export const isRichTextEditorRequired = value => (
    isEmpty(value) || isEditorValueStringEmpty(value) ? 'Required' : undefined
);

export const isRichTextImageEditorRequired = value => (
    isEmpty(value) || !value.getCurrentContent().hasText() ? 'This field is required' : undefined
);

export const isEmail = value =>
    value && !validator.isEmail(value)
        ? 'Invalid email address'
        : undefined;

export const isUsername =  value => value && !validator.isAlphanumeric(value) ? 'Invalid Username': undefined;

export const isUsernameOrEmail =  value =>
    value &&  ((isUsername(value)==='Invalid Username') ? ((isEmail(value)==='Invalid email address') ? 'Invalid Username' : undefined ) : undefined);

export const isValidModuleScore =  value => value && !validator.isInt(value, {gt: -1, lt: 11}) ? 'Score must be between 0-10': undefined;

export const isUrl = value => value && !validator.isURL(value) ? 'Invalid URL' : undefined;

// check file against the provided types
// types can be: mp4, mp3, pdf
export const isMediaValid = (file, types = []) => {
    const fType = file ? file.type : undefined;
    const supportedTypes = [];

    types.forEach(t => {
        if('mp4' === t) {
            supportedTypes.push('video/mp4');
        } else if('mp3' === t) {
            supportedTypes.push('audio/mp3');
        } else if('pdf' === t) {
            supportedTypes.push('application/pdf');
        }
    });

    return supportedTypes.includes(fType);
};

export const isStartDateBeforeEndDate = (value, values) => value &&
!moment(values.startDate).isBefore(values.endDate) ? 'End date must be after the start date' : undefined;

export const isStartDateSameOrBeforeEndDate = (value, values) => value &&
!moment(values.startDate).isSameOrBefore(values.endDate) ? 'End date must be the same or after the start date' : undefined;

/**
 * This is a function that return a validator. One should *NOT* use this to create a validator directly at
 * the `validate` property of `Field` from redux-form:
 * https://github.com/erikras/redux-form/issues/2453#issuecomment-272483784
 * The above implication will make the touched field untouched and thus screw up the validation state.
 * One can create the validator using this function at the parent component and pass it through props
 */
export const isBeforeExpiryDate = (expiryDate, itemName) => (value) => isEmpty(expiryDate) ?
    undefined :
    value && !moment(value).isBefore(momentDatetime(expiryDate)) ?
        `This date must be before the ${itemName}'s expiry date.` :
        undefined;

export const isAfterStartDate = (startDate, itemName) => (value) => isEmpty(startDate) ?
    undefined :
    value && !moment(value).isAfter(momentDatetime(startDate)) ?
        `This date must be after the ${itemName}'s start date.` :
        undefined;

export const isValidStudentPassword = value => value && !isValidPasswordLength(value) ?
    'The password must be at least 8 characters long.' : undefined;

export const isValidStudentPasswordSimplified = value => value && !isValidPasswordLength(value) ?
    'Must be at least 8 characters' : undefined;

export const isValidPassword = value => value && !isValidPasswordPattern(value) ?
    'The password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter,' +
    ' and a numeric digit.' : undefined;

export const isConfirmPasswordMatch = (value, values) => value && values.password !== values.confirmPassword ?
    'The passwords do not match, please try again.' : undefined;

export const isPositiveInteger = (value) => value && !/^[1-9][0-9]*$/.test(value) ?
    'Only positive numbers are allowed' : undefined;

export const isIntegerGreaterThanZero = (value) => value && !/^[0-9][0-9]*$/.test(value) ?
    'Must be greater than 0' : undefined;

export const isQuestionPoint = (value) => value &&
!/^(1(\.0+)?|0(\.[0-9]+)?)$/.test(value) ? 'Grade value must be between 0 and 1.0' : undefined;

export const isValidPoints = (value) => value &&
(!/^([0-9]|[1-9][0-9]+)$/.test(value) || parseInt(value) > 1000) ?
    'Invalid Points' : undefined;

export const isRubricWeight = (value) => {
    if(value && !/^(0|[1-9][0-9]*)$/.test(value)) {

        return 'Invalid Weight';
    } else if(parseInt(value) >= 1000) {

        return 'Must be below 1000';
    }

    return undefined;
};



// WEBPACK FOOTER //
// ./src/js/utilities/form/validators.js